const {
    REACT_APP_API_ROOT,
    REACT_APP_FILE_ROOT,
} = process.env;

// const config = {
//     API_ROOT: "http://hydrouz.beget.tech/api" || REACT_APP_API_ROOT,
//     FILE_ROOT: "http://hydrouz.beget.tech" || REACT_APP_FILE_ROOT,
// };

const config = {
    API_ROOT: REACT_APP_API_ROOT,
    FILE_ROOT: REACT_APP_FILE_ROOT,
};

export default config;